import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.instance = M.Tooltip.init(this.element,
      {
        enterDelay: this.element.dataset.tooltipEnterDelay || 200,
      }
    )

    const customClasses = this.element.dataset.tooltipClasses
    if (customClasses && this.instance.tooltipEl) {
      this.instance.tooltipEl.classList.add(...customClasses.split(' '))
    }
  }

  disconnect() {
    this.instance?.destroy()
  }
}
